import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FileAddOutlinedSvg from "@ant-design/icons-svg/es/asn/FileAddOutlined";
import AntdIcon from "../components/AntdIcon";
var FileAddOutlined = function FileAddOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileAddOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FileAddOutlined.displayName = 'FileAddOutlined';
}
export default /*#__PURE__*/React.forwardRef(FileAddOutlined);